// extracted by mini-css-extract-plugin
export default {"myProduct":"MyProducts_myProduct__FbixM","title":"MyProducts_title__6T85T"};